import { render, staticRenderFns } from "./yi-nav-header.vue?vue&type=template&id=49b1f579&"
import script from "./yi-nav-header.vue?vue&type=script&lang=js&"
export * from "./yi-nav-header.vue?vue&type=script&lang=js&"
import style0 from "./yi-nav-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "src/components/yi-nav-header/yi-nav-header.vue"
export default component.exports